import React from 'react'

function PermissionDenied() {
  return (
        <div className="container notfound">
            <div className="col-sm-1 brace">{`${'{'}`}</div>
            <div className="col-sm-10 main-info">
                <h1>BRAK UPRAWNIEŃ</h1>
                <h2>Nie masz uprawnień, by wykonać tę czynność</h2>
            </div>
            <div className="col-sm-1 brace">{`${'}'}`}</div>
        </div>

  )
}

export default PermissionDenied